import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Card, Spinner } from "react-bootstrap";
import { CircularProgress } from "@material-ui/core";
import styled from "styled-components";
import moment from "moment";
import { getParameterByName } from "../../../Utils/location";
import { apiGetOrientation, apiCheckinOrientation } from "../../../datasources/orientationRepo";

const CONTAINER = styled.div`
  .error {
    border: 1px solid #ff6565;
  }
`;

export function AttendanceOrientationPage() {
  const [idEvent, setIdEvent] = useState(null);
  const [dataEvent, setDataEvent] = useState(null);
  const [email, setEmail] = useState('');
  const [formState, setFormState] = useState({
    loading: false,
    error: false,
    message: null
  })
  const [resAttendance, setResAttendance] = useState(null);

  useEffect(() => {
    let idEvent = getParameterByName('id');
    setIdEvent(idEvent);
    getOrientation(idEvent);
  }, []);

  function getOrientation(idEvent){
    setFormState({
      ...formState,
      loading: true
    })
    apiGetOrientation({id: idEvent}).then((res) => {
      console.log(res);
      setDataEvent(res.data);
      setFormState({
        ...formState,
        loading: false
      })
    }).catch(err => {
      console.log(err);
      setFormState({
        ...formState,
        loading: false,
        error: true,
        message: err?.response?.data?.message
      })
    })
  }

  function submitData(){
    let payload = {
      id: idEvent,
      email: email,
    }
    setFormState({
      ...formState,
      loading: true
    })
    apiCheckinOrientation(payload).then((res) => {
      console.log(res);
      setFormState({
        ...formState,
        loading: false,
        error: false,
        message: res?.data?.message
      })
    }).catch(err => {
      setFormState({
        ...formState,
        loading: false,
        error: true,
        message: err?.response?.data?.message
      })
    })
  }

  return (
    <div
      className="d-flex align-item-center justify-content-center"
      style={{
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          height: "100vh",
          width: "100vw",
          backgroundImage: `url(assets/images/hold_heart.png)`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          filter: "blur(8px)",
          position: "absolute",
        }}
      />
      <Card style={{ width: "45rem", height: "25rem"}}>
        <Card.Header>
          <div className="col-lg-12 justify-content-center align-items-center d-flex">
            <div className="col-lg-2">
              <img
                alt="Logo"
                src={'assets/images/logo-interaktiv.png'}
                style={{
                  maxHeight: "45px",
                }}
              />
            </div>
            <div className="col-lg-8">
              <h5 className="text-center ">Attendance Orientation</h5>
            </div>
            <div className="col-lg-2" />
          </div>
        </Card.Header>
        <Card.Body>
          <CONTAINER>
            {dataEvent !== null ? (
              <Form>
                <Form.Group as={Row} className={"mb-1"}>
                  <Col lg={2} xs={0}/>
                  <Col lg={4} xs={6}>
                    <Form.Group>
                      <Form.Label style={{fontWeight: 'bold'}}>
                        Subject
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col lg={6} xs={6}>
                    <Form.Group>
                      <Form.Label>{dataEvent?.Subject}</Form.Label>
                    </Form.Group>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className={"mb-1"}>
                  <Col lg={2} xs={0}/>
                  <Col lg={4} xs={6}>
                    <Form.Group>
                      <Form.Label style={{fontWeight: 'bold'}}>
                        Start Date
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col lg={6} xs={6}>
                    <Form.Group>
                      <Form.Label>
                        {moment(dataEvent?.StartDateTime).format("DD MMMM YYYY hh:mm A")}
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className={"mb-1"}>
                  <Col lg={2} xs={0}/>
                  <Col lg={4} xs={6}>
                    <Form.Group>
                      <Form.Label style={{fontWeight: 'bold'}}>
                        End Date
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col lg={6} xs={6}>
                    <Form.Group>
                      <Form.Label>
                        {moment(dataEvent?.EndDateTime).format("DD MMMM YYYY hh:mm A")}
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className={"mb-1"}>
                  <Col lg={2} xs={0}/>
                  <Col lg={4} xs={6}>
                    <Form.Group>
                      <Form.Label style={{fontWeight: 'bold'}}>
                        Volunteer Location
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col lg={6} xs={6}>
                    <Form.Group>
                      {
                        dataEvent?.Location !== "" && dataEvent?.Location?.includes("http") ?
                        <a href={dataEvent?.Location} target="_blank">
                          <Form.Label style={{
                            color: 'blue',
                            textDecorationLine: 'underline',
                            cursor: 'pointer'
                          }}>{dataEvent?.Location}</Form.Label>
                        </a> :
                        <Form.Label>{dataEvent?.Location ? dataEvent?.Location : 'N/A'}</Form.Label>
                      }
                    </Form.Group>
                  </Col>
                </Form.Group>
                <Form.Group 
                  as={Row}
                  className={'align-items-center justify-content-center mb-5 mt-3'}
                >
                  <Col lg={12} xs={12} className={"align-items-center justify-content-center d-flex"}>
                    <Form.Text 
                      as={Row}
                      className={`${formState.error ? 'text-danger' : 'text-success'} mt-0 mb-0 align-items-center justify-content-center d-flex`}
                    >
                      { formState.message }
                    </Form.Text>
                  </Col>
                  <Col lg={8} xs={12} className={"align-items-center justify-content-center d-flex mt-2"}>
                    <Form.Control 
                      type="email" 
                      placeholder="email" 
                      style={{ width: "50%" }}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      disabled={resAttendance !== null}
                    />
                  </Col>
                  <Col lg={8} xs={12} className={"align-items-center justify-content-center d-flex mt-2"}>
                    <Button
                      variant={"primary"}
                      style={{ width: "auto", maxWidth: "50%", minWidth: "50%" }}
                      onClick={() => submitData()}
                      disabled={formState.loading}
                    >
                      Submit
                      {
                        formState.loading &&
                        <Spinner animation="border" role="status" size="sm">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      }
                    </Button>
                  </Col>
                </Form.Group>
              </Form>
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            )}
          </CONTAINER>
        </Card.Body>
      </Card>
    </div>
  );
}